<template lang="pug">
	main#app
		Header(v-if="$route.name != 'ead40' && $route.name != 'RedirectPortal'")
		Contador(v-if="$route.name != 'RedirectPortal'")
		router-view
		//- Chatbot(:key="chatBotConversationCount", @restart="chatBotConversationCount++", v-if="$route.name != 'RedirectPortal'")
		Cookie
		Footer(v-if="$route.name != 'RedirectPortal'")
		BarraConversao(v-if="$route.name != 'RedirectPortal'")
		CNPJ(v-if="$route.name != 'RedirectPortal'")
</template>

<script>
import Header from '@components/Header/Header'
import Contador from '@components/Contador/Contador'
import Footer from '@components/Footer/Footer'
import BarraConversao from '@components/BarraConversao/BarraConversao'
import CNPJ from '@components/Cnpj/Cnpj'
import Cookie from '@components/Cookie/Cookie.vue'
// import Chatbot from '@components/Chatbot/Chatbot'

export default {
	name: "template-app",
	components: {
		Header,
		Contador,
		Footer,
		// Chatbot,
		Cookie,
		CNPJ,
		BarraConversao
	},
	data() {
		return {
			// chatBotConversationCount: 1
		}
	},
}
</script>

<style lang="stylus" scoped src="@templates/App/App.styl"></style>
